import apontamentoColetasLocalizacaoReport from "entity/Indicador/reports/ApontamentoColetasLocalizacaoReport";
import apontamentoHeaderLocalizacaoReport from "entity/Indicador/reports/ApontamentoHeaderLocalizacaoReport";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";

export default async function Report(indicador, visita) {
    const IndicadorClass = indicador.constructor;

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];

    for (const apontamento of apontamentos) {
        const h = new TableReportHelper(apontamento);
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type)
        const configIndicador = { showTrator: false, showImplemento: false, showFrente: true, showMeta: false, }

        content.push(
            [
                await apontamentoHeaderLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    params,
                    "Consumo (kg)",
                    configIndicador,
                    {
                        label: "Operador",
                        field: "operador.operador",
                        width: "*"
                    }
                ),

                h.panel(
                    [
                        h.row(
                            h.title("Peso Médio (g)")
                        ),

                        h.row(
                            h.numberField("media", { digits: 3 })
                        ),
                    ],
                    { widths: ["*"] }
                ),

                await apontamentoColetasLocalizacaoReport(
                    visita,
                    indicador,
                    apontamento,
                    ["Peso (g)"],
                    // prettier-ignore
                    (h) => [
                        h.numberField("peso", { digits: 3 }),
                    ],
                    [60]
                ),

                apontamentoImagesReport(visita, indicador, apontamento),
                apontamentoObservacaoReport(visita, indicador, apontamento),

                h.space(),
            ]
        );
    }

    return content;
}
